import React from "react";
import { Link } from "react-router-dom";
import "../styles/Industries.css";


const industries = [
  {
    title: "IT&Technology",
    description:
      "Scalable digital solutions that help technology businesses innovate, grow, and stay competitive.",
      image:
      "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=900&q=80",

    
  },
  {
    title: "Healthcare",
    description:
      "Secure and user-friendly solutions that improve patient engagement, accessibility, and healthcare operations.",
      image:
      "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=900&q=80",

    
  },
  {
    title: "Education",
    description:
      "Connected digital platforms that enhance learning, communication, and institutional management.",
      image:
      "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=900&q=80",

    
  },
  {
    title: "Government Sectors",
    description:
      "Secure, accessible digital services that help public-sector teams serve communities with clarity, speed, and trust.",
    image:
      "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?auto=format&fit=crop&w=900&q=80",
  },
 /* {
    title: "Finance & FinTech",
    description:
      "Secure digital solutions for banking, payments, financial services, and modern FinTech businesses.",
       image:
      "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=900&q=80",
   
  },
  {
    title: "Real Estate",
    description:
      "Digital platforms that showcase properties, generate leads, and simplify customer interactions.",
      image:
      "https://images.unsplash.com/photo-1560518883-ce09059eeffa?auto=format&fit=crop&w=900&q=80",

    
  },*/
  {
    title: "ECommerce",
    description:
      "Powerful digital commerce solutions designed to improve shopping experiences, engagement, and sales.",
      image:
      "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=900&q=80",

    
  },
 /* {
    title: "Travel & Tourism",
    description:
      "Seamless digital experiences for travel discovery, booking, customer engagement, and tourism.",
      image:
      "https://images.unsplash.com/photo-1436491865332-7a61a109cc05?auto=format&fit=crop&w=900&q=80",

    
  },*/
  {
    title: "Hospitality",
    description:
      "Modern technology solutions that improve reservations, guest experiences, and hospitality operations.",
    image:
      "https://images.unsplash.com/photo-1564501049412-61c2a3083791?auto=format&fit=crop&w=900&q=80",

    
  },
  /*{
    title: "Food & Beverage",
    description:
      "Digital solutions that help restaurants and food businesses improve visibility, ordering, and customer engagement.",
      image:
      "https://images.unsplash.com/photo-1504674900247-0877df9cc836?auto=format&fit=crop&w=900&q=80",

    
  },
  {
    title: "Automobile",
    description:
      "Digital platforms that help automotive businesses showcase vehicles, generate inquiries, and connect with customers.",
      image:
      "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=900&q=80",

      
    
  },
  {
    title: "Manufacturing",
    description:
      "Smart digital solutions that streamline operations, improve workflows, and provide better business visibility.",
       image:
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&w=900&q=80",

   
  },*/
  {
    title: "Professional Services",
    description:
      "Digital solutions that strengthen credibility, attract clients, and simplify business processes.",
      image:
      "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=900&q=80",
    
  },
];

const industryLinks = {
  "IT&Technology": "/industries/technology",
  Healthcare: "/industries/healthcare",
  Education: "/industries/education",
  "Government Sectors": "/industries/government",
  ECommerce: "/industries/ecommerce",
  Hospitality: "/industries/hospitality",
  "Professional Services": "/industries/professional-services",
};

const reasons = [
  {
    title: "Business-Focused Digital Solutions",
    description:
      "We don't just build digital products — we create solutions around your business goals, customers, workflows, and long-term growth.",
  },
  {
    title: "Technology That Fits Your Needs",
    description:
      "From websites and mobile applications to CRM, ERP, API, and automation, we use the right technology to solve specific business challenges.",
  },
  {
    title: "Designed for Better Experiences",
    description:
      "We combine clean design, intuitive UX, and reliable technology to create digital experiences that are easy to use and built to engage your customers.",
  },
  {
    title: "Built to Scale",
    description:
      "Our solutions are designed with scalability in mind, allowing your digital ecosystem to evolve as your business grows and your requirements change.",
  },
  {
    title: "End-to-End Digital",
    description:
      "From strategy and design to development, production, and ongoing support, we help businesses build complete digital solutions.",
  },
];

const industryExtras = {
  government: { quote: "The new service journey gives our residents a much clearer route to the information and support they need.", role: "Public service operations lead", intro: "Our public-sector work brings together accessibility, secure delivery, and the practical needs of the people using each service." },
  hospitality: { quote: "The experience now feels joined up from first search through booking, arrival, and every guest request.", role: "Hospitality operations leader", intro: "We help hospitality teams connect digital discovery, guest service, and operational workflows into one considered experience." },
  professional: { quote: "Our expertise is much easier for prospective clients to understand, and our team has a clearer way to collaborate.", role: "Professional services director", intro: "We create digital foundations that make specialist expertise easier to find, choose, and experience." },
  ecommerce: { quote: "The store is faster to use, the checkout is clearer, and the team can finally see what is driving growth.", role: "eCommerce growth lead", intro: "We build connected commerce experiences that help customers buy with confidence and teams make better decisions." },
};

export function IndustryExtras({ type }) {
  const item = industryExtras[type];
  const otherIndustries = [
    { title: "IT & Technology", href: "/industries/technology", image: "https://images.unsplash.com/photo-1518770660439-4636190af475?auto=format&fit=crop&w=800&q=80" },
    { title: "Education", href: "/industries/education", image: "https://images.unsplash.com/photo-1509062522246-3755977927d7?auto=format&fit=crop&w=800&q=80" },
    { title: "Healthcare", href: "/industries/healthcare", image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?auto=format&fit=crop&w=800&q=80" },
    { title: "Government Sectors", href: "/industries/government", image: "https://images.unsplash.com/photo-1529107386315-e1a2ed48a620?auto=format&fit=crop&w=800&q=80" },
    { title: "Hospitality", href: "/hospitality", image: "https://images.unsplash.com/photo-1445019980597-93fa8acb246c?auto=format&fit=crop&w=800&q=80" },
    { title: "Professional Services", href: "/professional-services", image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?auto=format&fit=crop&w=800&q=80" },
    { title: "eCommerce", href: "/industries/ecommerce", image: "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=800&q=80" },
  ].filter((industry) => industry.href !== ({ government: "/industries/government", hospitality: "/industries/hospitality", professional: "/industries/professional-services", ecommerce: "/industries/ecommerce" })[type]);
  return <>
    <section className="industry-testimonials"><div className="testimonial-copy"><span>Client perspective</span><h2>Built around work that <em>matters.</em></h2><p>{item.intro}</p></div><article className="testimonial-card"><div className="stars">★★★★★</div><blockquote>“{item.quote}”</blockquote><p>{item.role}</p></article></section>
    <section className="other-industries"><span>Explore more</span><h2>EXPLORE OTHER INDUSTRIES<br />WE SERVE</h2><p>Our technology, design, and delivery expertise adapts to the distinct challenges and opportunities of every sector.</p><div className="other-industries-grid">{otherIndustries.map((industry) => <Link to={industry.href} key={industry.title}><img src={industry.image} alt="" /><strong>{industry.title}</strong><b>↗</b></Link>)}</div></section>
  </>;
}

function Industries() {
  return (
    <main className="industries-page">

      {/* HERO */}
      <section className="industries-hero">
        <div className="hero-glow"></div>

        <div className="hero-content">
          <h2>
            <span className="hero-title">Industries </span>
            <span className="hero-subtitle">
              we <strong>serve</strong>
            </span>
          </h2>

          <div className="hero-description">
            <p>
              We build industry-focused digital solutions that combine
              technology, design, and strategy to solve real business
              challenges, improve customer experiences, and support
              sustainable growth.
            </p>

            <a href="#industries-grid" className="gold-button">
              Explore Now <span>→</span>
            </a>
          </div>
        </div>

        <div className="hero-orb">
          <div className="orb-highlight"></div>
        </div>
      </section>

      {/* INDUSTRIES */}
      <section className="industries-section" id="industries-grid">
        <div className="industries-intro">
          <span className="intro-eyebrow">Industry expertise</span>
          <p>
            Explore our industry expertise and discover digital solutions
            tailored to the unique needs of your business.
          </p>

          <div className="intro-stat"><strong>7+</strong><span>sectors supported<br />by one digital team</span></div>

          <a href="#contact" className="gold-button">
            Start Now <span>→</span>
          </a>
        </div>

        <div className="industries-grid">
          {industries.map((industry) => (
            <Link
              to={industryLinks[industry.title]}
              className={`industry-card${industry.title === "Professional Services" ? " industry-card--professional" : ""}`}
              
              key={industry.title}
              aria-label={`Explore ${industry.title}`}
            >
              <div className="card-top">
                <h3>{industry.title}</h3>
              </div>

              <p>{industry.description}</p>

              <div className="industry-image-wrapper">
                <img
                  src={industry.image}
                  alt={industry.title}
                  className="industry-image"
                />
              </div>
            </Link>
          ))}
        </div>
      </section>

      {/* WHY US */}
      <section className="why-section">
        <div className="why-intro">
          <p>
            We help businesses turn industry challenges into digital
            opportunities through innovative technology, strategic thinking,
            and user-focused solutions.
          </p>

          <a href="#contact" className="gold-button">
            Plan Your Project <span>→</span>
          </a>
        </div>

        <div className="why-content">
          <h2>Why <em>Techlynx</em> Solutions</h2>

          <div className="reason-list">
            {reasons.map((reason, index) => (
              <div className="reason-item" key={index}>
                <div className="reason-text">
                  <h3>{reason.title}</h3>
                  <p className="reason-description">{reason.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="industry-cta" id="contact">
        <div className="cta-glow"></div>

        <div className="cta-text">
          <span>Build Your Digital Future</span>

          <h2>
            Digital Solutions
            <br />
            Designed Around
            <br />
            <strong>Your Industry</strong>
          </h2>
        </div>

        <div className="cta-visual">
          <div className="mockup laptop">
            <div className="mockup-screen">
              {"</>"}
            </div>
          </div>

          <div className="mockup phone">
            <div className="mockup-screen">✦</div>
          </div>

          <div className="floating-icon icon-one">↗</div>
          <div className="floating-icon icon-two">⌘</div>
          <div className="floating-icon icon-three">◆</div>
        </div>

        <div className="cta-right">
          <p>
            Every industry has unique challenges, customers, and
            opportunities. Our solutions create tailored digital solutions
            that align with your business needs.
          </p>

          <Link to="/contact" className="gold-button">
            Start a Project <span>→</span>
          </Link>
        </div>
      </section>

    </main>
  );
}

export default Industries;
